import { Component } from '@angular/core';
import { ModalController, NavParams } from 'ionic-angular';

import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
import { MateriaisService } from '../../../../providers/materiais-service';
import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";

import { ModalPreVisualizarMateriaisPage } from '../../../modais/modal-pre-visualizacao/materiais/modal-pv-materiais';

@Component({
  selector: 'page-resumo-analise',
  templateUrl: 'resumo-analise.html',
  providers: [
    MateriaisService
  ]
})
export class MateriaisResumoAnalisePage extends ModulosController {
  listaAnalises: any[];
  loading: boolean = true;
  tituloPagina: string = "";
  // isJurisdicionado: boolean;
  constructor(
    private materiaisService: MateriaisService,
    public alertService: AlertService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarDados();

    this.setModuloId(13);
  }

  carregarDados() {

    if (!this.isJurisdicionado) {
      this.materiaisService.obterListaAnalises(this.materiaisService.codigoModuloMateriais).subscribe(data => {
        this.listaAnalises = data;
        
        this.listaAnalises.forEach(x => {
          if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
            x.idStatusAnalise = 11;
            x.dsStatusAnalise = 'Para Consulta';
          }
        });

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    } else {
      this.materiaisService.obterListaAnalisesJur(this.materiaisService.codigoModuloMateriais).subscribe(data => {
        this.listaAnalises = data;
        
        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
  }

  redirecionarParaAnalise(analise) {
    analise.cdModulo = this.materiaisService.obterIdPaginaMateriais();
    this.menuService.redirecionarSubPagina(this.materiaisService.obterIdPaginaMateriais(), analise);
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';
    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  naoSeAplica(item) {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 13).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'MATERIAIS',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  naoSeAplicaAnalise(item) {

    this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloAnalise: data,
          IdProcesso: data.moduloAnalise,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'MATERIAIS',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarDados();
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();

    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  previsualizarCertificado() {

    let modal = this.modalCtrl.create(ModalPreVisualizarMateriaisPage, {});
    modal.onDidDismiss(retornoModal => {
      //retorno da modal
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/materiais/resumo-analise/resumo-analise.ts